/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WebApiCustomListsDtoCustomListHistoryChangeDto
 */
export interface WebApiCustomListsDtoCustomListHistoryChangeDto {
    /**
     * 
     * @type {number}
     * @memberof WebApiCustomListsDtoCustomListHistoryChangeDto
     */
    fieldId?: number;
    /**
     * 
     * @type {string}
     * @memberof WebApiCustomListsDtoCustomListHistoryChangeDto
     */
    fieldName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiCustomListsDtoCustomListHistoryChangeDto
     */
    oldValue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiCustomListsDtoCustomListHistoryChangeDto
     */
    newValue?: string | null;
}

/**
 * Check if a given object implements the WebApiCustomListsDtoCustomListHistoryChangeDto interface.
 */
export function instanceOfWebApiCustomListsDtoCustomListHistoryChangeDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiCustomListsDtoCustomListHistoryChangeDtoFromJSON(json: any): WebApiCustomListsDtoCustomListHistoryChangeDto {
    return WebApiCustomListsDtoCustomListHistoryChangeDtoFromJSONTyped(json, false);
}

export function WebApiCustomListsDtoCustomListHistoryChangeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiCustomListsDtoCustomListHistoryChangeDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fieldId': !exists(json, 'fieldId') ? undefined : json['fieldId'],
        'fieldName': !exists(json, 'fieldName') ? undefined : json['fieldName'],
        'oldValue': !exists(json, 'oldValue') ? undefined : json['oldValue'],
        'newValue': !exists(json, 'newValue') ? undefined : json['newValue'],
    };
}

export function WebApiCustomListsDtoCustomListHistoryChangeDtoToJSON(value?: WebApiCustomListsDtoCustomListHistoryChangeDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fieldId': value.fieldId,
        'fieldName': value.fieldName,
        'oldValue': value.oldValue,
        'newValue': value.newValue,
    };
}

